module.exports = __webpack_public_path__ + "img/cs-home-2.aa64148a.jpg";